// import React, { useState } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import axios from 'axios';
//   const ResetPassword = () => {
//   const [password, setPassword] = useState('');
//   const [confirmPassword, setConfirmPassword] = useState('');
//   const [error, setError] = useState('');
//   const [success, setSuccess] = useState(false);
//   const { token } = useParams();
//   const[email, setEmail]=useState()
//   const navigate = useNavigate();

//   // const handleSubmit = async (e) => {
//   //   e.preventDefault();
    
//   //   if (password !== confirmPassword) {
//   //     setError("Passwords don't match");
//   //     return;
//   //   }
    
//   //   try {
//   //     const response = await fetch(`/api/reset-password/${token}`, {
//   //       method: 'POST',
//   //       headers: {
//   //         'Content-Type': 'application/json',
//   //       },
//   //       body: JSON.stringify({ newPassword: password }),
//   //     });
      
//   //     if (response.ok) {
//   //       setSuccess(true);
//   //       setTimeout(() => {
//   //         navigate('/login');
//   //       }, 3000);
//   //     } else {
//   //       const data = await response.text();
//   //       setError(data);
//   //     }
//   //   } catch (err) {
//   //     setError('An error occurred. Please try again.');
//   //   }
//   // };
//   const handleSubmit = async (e) => {
//     e.preventDefault();
  
//     try {
//       const response = await axios.post(`http://localhost:3000/reset-password/${token}`, {
//         username: email, // User's email
//         password, // New password entered by the user
//         // resetToken: token, // Optional if implemented server-side
//       });
  
//       if (response.status === 200) {
//         alert("Password has been reset successfully.");
//       }
//     } catch (error) {
//       alert("Failed to reset password. Please try again.");
//     }
//   };
  
//   return (
//     <div className="max-w-md mx-auto mt-10 p-6 bg-white rounded-lg shadow-md">
//       <h2 className="text-2xl font-bold mb-6">Reset Password</h2>
      
//       {success ? (
//         <div className="bg-green-100 p-4 rounded mb-4">
//           Password successfully reset! Redirecting to login...
//         </div>
//       ) : (
//         <form onSubmit={handleSubmit}>
//           {error && (
//             <div className="bg-red-100 p-4 rounded mb-4">
//               {error}
//             </div>
//           )}
          
//           <div className="mb-4">
//             <label className="block mb-2">New Password</label>
//             <input
//               type="password"
//               className="w-full p-2 border rounded"
//               value={password}
//               onChange={(e) => setPassword(e.target.value)}
//               required
//               minLength={6}
//             />
//           </div>
          
//           <div className="mb-6">
//             <label className="block mb-2">Confirm Password</label>
//             <input
//               type="password"
//               className="w-full p-2 border rounded"
//               value={confirmPassword}
//               onChange={(e) => setConfirmPassword(e.target.value)}
//               required
//               minLength={6}
//             />
//           </div>
          
//           <button
//             type="submit"
//             className="w-full bg-blue-500 text-white py-2 rounded hover:bg-blue-600"
//           >
//             Reset Password
//           </button>
//         </form>
//       )}
//     </div>
//   );
// };

// export default ResetPassword;





import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

const ResetPassword = () => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const { token } = useParams();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      setError("Passwords don't match");
      return;
    }

    if (password.length < 6) {
      setError("Password must be at least 6 characters");
      return;
    }

    try {
      const response = await axios.post(`/reset-password/${token}`, {
        password: password,
      });

      if (response.status === 200) {
        setSuccess(true);
        setTimeout(() => navigate('/login'), 3000);
      }
    } catch (err) {
      setError(err.response?.data || "Failed to reset password. Link may have expired.");
    }
  };

  return (
    <div className="container h-100">
      <div
        className="row h-100 justify-content-center align-items-center"
        style={{ marginTop: "80px", marginBottom: "20px" }}
      >
        <div className="col-md-5">
          <div className="AppForm shadow-lg p-4">
            <h2 className="text-center mb-4">Reset Password</h2>

            {success ? (
              <div className="alert alert-success text-center">
                Password reset successful! Redirecting to login...
              </div>
            ) : (
              <>
                {error && (
                  <div className="alert alert-danger">{error}</div>
                )}

                <div className="form-group position-relative mb-4">
                  <label>New Password</label>
                  <input
                    type="password"
                    className="form-control"
                    value={password}
                    onChange={(e) => {
                      setPassword(e.target.value);
                      setError('');
                    }}
                    placeholder="Enter new password"
                    required
                    minLength={6}
                    style={{ color: "black", border: "1px solid #ccc" }}
                  />
                </div>

                <div className="form-group position-relative mb-4">
                  <label>Confirm Password</label>
                  <input
                    type="password"
                    className="form-control"
                    value={confirmPassword}
                    onChange={(e) => {
                      setConfirmPassword(e.target.value);
                      setError('');
                    }}
                    placeholder="Confirm new password"
                    required
                    minLength={6}
                    style={{ color: "black", border: "1px solid #ccc" }}
                  />
                </div>

                <button
                  onClick={handleSubmit}
                  className="btn btn-success btn-block shadow border-0 py-2 text-uppercase w-100"
                >
                  Reset Password
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;